<template>
  <div class="p-2">
    <b-card
      :title="aTitle"
      :img-src="aImg"
      :img-alt="aTitle"
      img-top
      tag="article"
      style="max-width:20rem;height:100%;"
      class="mb-2"
      :class="{'b-card-disabled': !isEnabled}"
      v-b-popover.hover="isEnabled ? '' : aDisabledText"
     >
      <p class="card-text">
        {{ aDescription }}
      </p>
      <div slot="footer">
        <b-button
          :variant="enabled ? 'primary':'secondary'"
          class="w-100"
          @click="open"
          :disabled="!isEnabled"
        >
          {{ aAction }}
          <b-badge v-if="aBadgeInfo" variant="light">{{badgeText}}</b-badge>
        </b-button>
      </div>
    </b-card>
  </div>
</template>

<script>
export default {
  name: 'FeatureCard',
  props: {
    img: { type: String, required: true },
    title: { type: String, required: true },
    description: { type: String, required: true },
    action: { type: String, default: 'Accedi' },
    route: { type: [String, Object], default: '/' },
    enabled: { type: Boolean, default: true },
    disabledText: { type: String, default: 'Funzione attualmente non disponibile' },
    badgeInfo: { type: String, default: null }
  },
  data () {
    return {
      badgeText: ''
    }
  },
  computed: {
    aImg () { return this.img },
    aTitle () { return this.title },
    aDescription () { return this.description },
    aAction () { return this.action },
    aRoute () { return this.route },
    isEnabled () { return this.enabled },
    aDisabledText () { return this.disabledText },
    aBadgeInfo () { return this.badgeInfo }

  },
  async created () {
    this.badgeText = this.aBadgeInfo ? await this.badgeValue() : ''
  },

  methods: {
    open () {
      if (this.isEnabled) this.$router.push(this.route)
    },
    async badgeValue () {
      let retValue
      try {
        await this.$store.dispatch(this.aBadgeInfo + '/countOpen')
        retValue = this.$store.state[this.aBadgeInfo].open || 0
        // console.log('Cerca conteggio', this.aBadgeInfo + '/countOpen', this.$store.state[this.aBadgeInfo], this.$store.state[this.aBadgeInfo].open)
        // console.log('this.dichiarazioniIsVisible', this.dichiarazioniIsVisible)
      } catch (err) {
        this.$ui.showError(err)
      }
      return retValue
    }

  }
}
</script>

<style lang="stylus" scoped>
h4 {
  font-size: 1.2rem;
}

.b-card-disabled {
  background: #ddd;
}
</style>
